(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["photogallery"] = factory();
	else
		root["photogallery"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/++theme++sc.photogallery/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
__webpack_require__(2);
__webpack_require__(3);
module.exports = __webpack_require__(4);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "photogallery.css";

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PhotoGallery = function () {
  function PhotoGallery(el) {
    _classCallCheck(this, PhotoGallery);

    this.$el = $(el);
    this.proportion = 3 / 2;
    this.bind_events();
    this.fix_image_size();
  }

  _createClass(PhotoGallery, [{
    key: '$',
    value: function (_$) {
      function $(_x) {
        return _$.apply(this, arguments);
      }

      $.toString = function () {
        return _$.toString();
      };

      return $;
    }(function (selector) {
      return $(selector, this.$el);
    })
  }, {
    key: 'bind_events',
    value: function bind_events() {
      this.$('.cycle-player').on('cycle-next cycle-prev', this.sync_slideshows.bind(this));
      this.$('.cycle-carrossel .thumb-itens').on('click', this.thumbs_click.bind(this));
    }
  }, {
    key: 'fix_image_size',
    value: function fix_image_size() {
      var max_height = void 0,
          max_width = void 0,
          $player = void 0,
          $imgs = void 0;

      // Calc max_with and max_height
      $player = this.$('.cycle-player');
      max_width = $player.width();
      max_height = max_width / this.proportion;
      // Calc max_with and max_height

      $imgs = this.$('.cycle-player img');
      $imgs.css({
        'max-width': max_width,
        'max-height': max_height
      });
    }
  }, {
    key: 'sync_slideshows',
    value: function sync_slideshows(e, opts) {
      var index = void 0,
          $player = void 0,
          $slideshows = void 0;
      $slideshows = this.$('.cycle-slideshow');
      $slideshows.cycle('goto', opts.currSlide);
    }
  }, {
    key: 'thumbs_click',
    value: function thumbs_click(e) {
      var index = void 0,
          $thumbs = void 0,
          $slideshows = void 0;
      e.preventDefault();
      $thumbs = this.$('.cycle-carrossel');
      index = $thumbs.data('cycle.API').getSlideIndex(e.target.parentElement);
      $slideshows = this.$('.cycle-slideshow');
      $slideshows.cycle('goto', index);
    }
  }]);

  return PhotoGallery;
}();

$(window).load(function () {
  var i = void 0,
      len = void 0,
      ref = void 0,
      slideshow = void 0;
  ref = $('.slideshow-container');
  for (i = 0, len = ref.length; i < len; i++) {
    slideshow = ref[i];
    new PhotoGallery(slideshow);
  }
});

module.exports = {
  PhotoGallery: PhotoGallery
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "photogallery_icon.png";

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tile-photogallery.png";

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// photogallery.js